export const objectEntries = <Obj extends object>(
  obj: Obj,
): [keyof Obj, Obj[keyof Obj]][] =>
  Object.entries(obj) as [keyof Obj, Obj[keyof Obj]][];

export const objectKeys = <Obj extends object>(obj: Obj): (keyof Obj)[] =>
  Object.keys(obj) as (keyof Obj)[];